import {
  DBTagMentionNode,
  ExegesisSlateBlock,
  IInsertPrivateContentParams,
  Slate_RequiredPrivateContentFields,
} from '@rhizome/pgtypes';

export const CreateNewPrivateContentRow = (
  el: Slate_RequiredPrivateContentFields
): Omit<IInsertPrivateContentParams, 'slate_content'> & {
  slate_content: ExegesisSlateBlock<DBTagMentionNode>;
} => {
  return {
    ...el,
    text_title: null,
    text_body: null,
    author: null,
    image_url: null,
    url_url: null,
    url_site: null,
    url_media: null,
    slide_content: null,
  };
};
